<template>
  <div class='massLoss-list' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='form' label-width='80px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='质损编号:'>
          <el-input v-model='form.number' size='mini' placeholder='请输入质损编号'></el-input>
        </el-form-item>
        <!--        <el-form-item label='任务编号:'>
                  <el-input v-model='form.taskNumber' size='mini' placeholder='请输入任务编号'></el-input>
                </el-form-item>-->
        <el-form-item label='运输条款:'>
          <el-select v-model='form.taskMode' filterable size='mini' placeholder='请选择运输条款'>
            <el-option value='0' label='公路'></el-option>
            <el-option value='1' label='水路'></el-option>
            <!-- <el-option value="3" label="水陆联运"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label='托运商:'>
          <el-input v-model='form.supplierName' size='mini' placeholder='请输入托运商名称'></el-input>
        </el-form-item>
        <el-form-item label='批次号:'>
          <el-input v-model='form.batchNumber' size='mini' placeholder='请输入质损车批次号'></el-input>
        </el-form-item>
        <el-form-item label='车架号:'>
          <el-input v-model='form.frameNumber' size='mini' placeholder='请输入质损车车架号'
                    @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}"></el-input>
        </el-form-item>
        <!-- <el-form-item label="创建时间:">
          <el-date-picker
            v-model="form.time"
            type="date"
            size="mini"
            placeholder="请选择创建时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审核状态:">

          <el-select v-model="form.status" filterable size="mini" placeholder="请选择状态">
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="未通过" value="3"></el-option>
            <el-option label="已取消" value="4"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style='float:right'>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <!-- <el-button size="small" type="primary" @click="addBtn">新增</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='importUploadUrl' @importSuccess='searchBtn'
                        @triggerLoading='importLoading = !importLoading' />
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
        >
          <el-table-column label='序号' align='center' width='50px'>
            <div slot-scope='scope'>{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop='number' label='质损编号' align='center' min-width='140px' />
          <!--          <el-table-column prop='taskNumber' label='任务编号' align='center' />-->
          <el-table-column prop='taskMode' :formatter='getTaskMode' label='运输条款' align='center'
                           min-width='80px' />
          <el-table-column prop='taskSupplierName' label='托运商' align='center' min-width='140px' />
          <el-table-column prop='taskPeopleName' label='司机/船长姓名' align='center' />
          <el-table-column prop='transportValue' label='车牌号/航次' align='center' min-width='100px' />
          <el-table-column prop='batchNumber' label='批次号' align='center' min-width='100px' />
          <el-table-column prop='frameNumber' label='质损车架号' align='center' min-width='140px' />
          <!-- <el-table-column prop="nameTell" label="品牌" align="center"/>
          <el-table-column prop="nameTell" label="型号" align="center"/> -->
          <el-table-column prop='typeName' label='质损类型' align='center' />
          <el-table-column prop='partName' label='质损部位' align='center' />
          <!--          <el-table-column prop="status" label="状态" :formatter="getStatus" align="center"/>-->
          <el-table-column prop='status' label='状态' :formatter='getStatus' align='center'>
            <template slot-scope='scope'>
              <p v-if='scope.row.status==0'>完善信息</p>
              <p v-else-if='scope.row.status==1'>已完善信息待付款</p>
            </template>
          </el-table-column>
          <el-table-column label='操作' width='200' align='center'>
            <template slot-scope='scope'>
              <div>
                <el-button size='mini' class='searchBtn' type='primary' :loading='infoLoading'
                           @click='detailClick(scope.$index, scope.row)'>详情
                </el-button>
                <el-button size='mini' class='yellow-bg' :loading='addLoading'
                           v-if='scope.row.buttonJudgment!=1'
                           @click='perfectClick(scope.$index, scope.row)'>完善
                </el-button>
                <!-- <el-button  size="mini" type="danger" @click="rejectClick(scope.$index, scope.row)">取消申请</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog title='完善质损维修信息' :visible.sync='addflag' width='700px' center @close='dialogClose'>
      <div class='add'>
        <div class='baseInfo'>
          <div class='baseInfoContent'>
            <!-- label-position="left" -->
            <el-form :model='modifyData' label-width='155px' :rules='rules' ref='ruleForm'
                     class='demo-ruleForm'>
              <div-border label='质损车信息'>
                <div class='yang'>
                  <el-form-item label='质损单号:' style='margin-top: 15px'>{{ detailData.number || '无'
                    }}
                  </el-form-item>
                  <el-row>
                    <el-col :span='13'>
                      <el-form-item label='任务编号:'>{{ detailData.taskNumber || '无' }}</el-form-item>
                    </el-col>
                    <el-col :span='11'>
                      <el-form-item label-width='100px' label='运输条款:'>{{ detailData.taskMode || '无'
                        }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span='13'>
                      <el-form-item label='托运商:'>{{ detailData.taskSupplierName || '无' }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='11'>
                      <el-form-item label-width='100px' label='车牌/航次:'>
                        {{ detailData.transportValue || '无' }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span='24'>
                      <el-form-item label='司机/船长姓名:'>{{ detailData.taskPeopleName || '无' }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span='13'>
                      <el-form-item label='批次号:'>{{ detailData.batchNumber || '无' }}</el-form-item>
                    </el-col>
                    <el-col :span='11'>
                      <el-form-item label-width='100px' label='车架号:'>
                        {{ detailData.frameNumber || '无' }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span='13'>
                      <el-form-item label='品牌:'>{{ detailData.vdcc ? detailData.vdcc.brand : '无' }}
                      </el-form-item>
                    </el-col>
                    <el-col :span='11'>
                      <el-form-item label-width='100px' label='型号:'>
                        {{ detailData.vdcc ? detailData.vdcc.model : '无' }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div-border>
              <div-border label='维修信息'>
                <div class='repair'>
                  <el-form-item label='维修内容:' style='margin-top:15px;' prop='repairContent'>
                    <el-input v-model='modifyData.repairContent' size='mini'
                              placeholder='请输入维修内容'></el-input>
                  </el-form-item>
                  <el-form-item label='定价金额:' prop='pricingAmount'>
                    <el-input v-model='modifyData.pricingAmount' size='mini'
                              placeholder='请输入定价金额'></el-input>
                  </el-form-item>
                  <el-form-item label='维修扣款时间:' prop='Time'>
                    <el-date-picker
                      v-model='modifyData.Time'
                      type='date'
                      placeholder='选择日期时间'
                      size='mini'
                      value-format='yyyy-MM-dd'>
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label='是否处罚:' prop='punishFlag'>
                    <el-radio-group v-model='modifyData.punishFlag'>
                      <el-radio :label='0'>否</el-radio>
                      <el-radio :label='1'>是</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label='处罚金额:' v-if='modifyData.punishFlag ===1' prop='punishAmount'
                                style='margin-bottom: 20px'>
                    <el-input v-model='modifyData.punishAmount' size='mini'
                              placeholder='请输入处罚金额'></el-input>
                  </el-form-item>
                </div>
              </div-border>
              <div-border label='保险信息'>
                <div class='repair'>
                  <el-form-item label='是否有保险:' style='margin-top:15px;' prop='Insurance'>
                    <el-radio-group v-model='modifyData.Insurance'>
                      <el-radio :label='0'>否</el-radio>
                      <el-radio :label='1'>是</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div v-if='modifyData.Insurance ===1'>
                    <el-form-item label='向保险公司索赔时间:' prop='claimTime'>
                      <el-date-picker
                        v-model='modifyData.claimTime'
                        type='date'
                        size='mini'
                        placeholder='请选择向保险公司索赔时间'
                        value-format='yyyy-MM-dd'
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label='保险公司回款金额:' prop='CollectionAmount'
                                  style='margin-bottom: 20px'>
                      <el-input v-model='modifyData.CollectionAmount' size='mini'
                                placeholder='请输入保险公司回款金额'></el-input>
                    </el-form-item>
                    <el-form-item label='保险公司回款时间:' prop='CollectionTime'>
                      <el-date-picker
                        v-model='modifyData.CollectionTime'
                        type='date'
                        size='mini'
                        placeholder='请选择保险公司回款时间'
                        value-format='yyyy-MM-dd'
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label='保险单号:' prop='InsuranceNumber'>
                      <el-input v-model='modifyData.InsuranceNumber' size='mini'
                                placeholder='请输入保险单号'></el-input>
                    </el-form-item>
                    <el-form-item label='上传保险:' prop='img' style='margin-bottom: 20px'>
                      <div class='imgUp'>
                        <div class='imgLength'><span>{{ modifyData.img.length }}/5</span></div>
                        <el-upload
                          ref='upload'
                          list-type='picture-card'
                          :action='uploadUrl'
                          :auto-upload='true'
                          accept='image/png, image/jpeg, image/jpeg, image/bmp, image/gif'
                          :before-upload='beforeAvatarUpload'
                          :on-change='uploadChange'
                          :on-remove='handleRemove'
                          :on-preview='handlePictureCardPreview'
                          :file-list='modifyData.img'
                          :limit='5'
                        >
                          <i class='el-icon-plus' />
                        </el-upload>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div-border>
            </el-form>
            <div class='btnContainer'>
              <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick'>确认
              </el-button>
              <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync='dialogVisible' append-to-body>
        <img width='100%' :src='dialogImageUrl' alt=''>
      </el-dialog>
    </el-dialog>

    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='623px' center>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ detailData.status }}</p>
          </div>
          <el-form :model='detailData' label-position='left'>
            <div class='baseInfoContent'>
              <el-form-item label='质损单号:'>
                <span>{{ detailData.number || '无' }}</span>
              </el-form-item>
              <el-row>
                <el-col :span='12'>
                  <el-form-item label='任务编号:'>
                    <span>{{ detailData.taskNumber || '无' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item label='运输条款:'>
                    <span>{{ detailData.taskMode || '无' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='12'>
                  <el-form-item label='托运商:'>
                    <span>{{ detailData.taskSupplierName || '无' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item label='车牌/航次:'>
                    <span>{{ detailData.transportValue || '无' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='24'>
                  <el-form-item label='司机/船长姓名:'>
                    <span>{{ detailData.taskPeopleName || '无' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='12'>
                  <el-form-item label='批次号:'>
                    <span>{{ detailData.batchNumber || '无' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item label='车架号:'>
                    <span>{{ detailData.frameNumber || '无' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='12'>
                  <el-form-item label='品牌:'>
                    <span>{{ detailData.vdcc ? detailData.vdcc.brand : '无' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item label='型号:'>
                    <span>{{ detailData.vdcc ? detailData.vdcc.model : '无' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='24'>
                  <el-form-item label='颜色:'>
                    <span>{{ detailData.vdcc ? detailData.vdcc.color : '无' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-form-item label="评审需求:">
                <span>{{detailData.type}}</span>
              </el-form-item>
              <el-form-item label="图片:">
              </el-form-item> -->
              <el-row>
                <el-image
                  v-for='(item,index) in detailData.attachmentList'
                  :key='index'
                  style='width: 100px; height: 100px;margin-right:10px; '
                  :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item.id)+'&access_token='+token"
                  :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item.id)+'&access_token='+token]"
                  fit='cover' />
              </el-row>
            </div>
            <div class='operation'>
              <div class='operationTitle'>
                <div class='line' />
                <span>质损信息</span>
              </div>
              <div class='operationContent'>
                <!-- <steps :step-data="stepData" :step-state="stepState"/> -->
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='质损类型:'>
                      <span>{{ detailData.typeName || '无' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='质损部位:'>
                      <span>{{ detailData.partName || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col :span="24">
                    <el-form-item label="质损部位(具体):">
                      <span>{{detailData.referred}}</span>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='质损情况:'>
                      <span>{{ detailData.situation || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col :span="24">
                    <el-form-item >
                      <el-image
                        v-for="(item,index) in detailData.idCard" :key="index"
                        style="width: 100px; height: 100px;margin-right:10px; "
                        :src="item"
                        fit="cover"/>
                    </el-form-item>
                  </el-col>
                </el-row> -->
              </div>
            </div>
            <div class='operation'>
              <div class='operationTitle'>
                <div class='line' />
                <span>维修信息</span>
              </div>
              <div class='operationContent'>
                <!-- <steps :step-data="stepData" :step-state="stepState"/> -->
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='是否处罚:'>
                      <span>{{ detailData.isPunish || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='维修内容:'>
                      <span>{{ detailData.maintainContent || '无' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='定损金额:'>
                      <span>{{ detailData.pricingAmount || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='处罚金额:'>
                      <span>{{ detailData.punishAmount || '无' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='扣款时间:'>
                      <span>{{ detailData.processingDate || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class='operation'>
              <div class='operationTitle'>
                <div class='line' />
                <span>保险信息</span>
                <!-- <p>{{detailData.state}}</p> -->
              </div>
              <div class='operationContent'>
                <!-- <steps :step-data="stepData" :step-state="stepState"/> -->
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='向保险公司索赔时间:'>
                      <span>{{ detailData.claimCompensationDate || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='保险公司回款金额:'>
                      <span>{{ detailData.receivableAmount || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='保险公司回款时间:'>
                      <span>{{ detailData.returnedMoneyDate || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='24'>
                    <el-form-item label='保险单号:'>
                      <span>{{ detailData.policyNumber || '无' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='24'>
                    <el-form-item>
                      <el-image
                        v-for='(item,index) in detailData.idCard' :key='index'
                        style='width: 100px; height: 100px;margin-right:10px; '
                        :src='item'
                        fit='cover' />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class='operation'>
              <div class='operationTitle'>
                <div class='line' />
                <span>操作记录</span>
              </div>
              <div class='operationTable'>
                <!-- <steps :step-data="stepData" :step-state="stepState"/> -->
                <el-table :data='detailData.operateRecordList' border
                          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}">
                  <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
                  <el-table-column prop='operateType' label='操作类型' align='center' />
                  <el-table-column prop='operationName' label='操作人' align='center' />
                  <el-table-column prop='remark' label='备注' align='center' />
                </el-table>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl,
  } from '@/config/env';
  import uploadImg from '@/components/uploadImg';
  import divBorder from '@/components/divBorder';
  import steps from '@/components/steps';
  import BatchImport from '@/components/batchImport';
  import { getSessionStore } from '@/config/mUtils';
  import {
    qualityDamageList,
    qualityDamageDetail,
    qualityDamageRepair,
    qualityDamageInsurance,
  } from '@/service/vehiclelog';

  export default {
    components: {
      uploadImg,
      divBorder,
      steps,
      BatchImport,
    },
    data() {
      return {
        importLoading: false,
        form: {
          taskMode: '', // 运输条款
          supplierName: '', // 托运商
          batchNumber: '', // 批次号
          frameNumber: '', //车架号
          number: '', //质损编号
          taskNumber: '', // 任务编号
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        token: getSessionStore('token'),
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {
          status: '',
          number: '',
          batchNumber: '',
          frameNumber: '',
          driverName: '',
          supplierName: '',
          vehicleNumber: '',
          taskNumber: '',
          taskMode: '',
          typeName: '',
          partName: '',
          situation: '',
          maintainContent: '',
          pricingAmount: '',
          isPunish: '',
          punishAmount: '',
          claimCompensationDate: '',
          returnedMoneyDate: '',
          policyNumber: '',
          processingDate: '',
          receivableAmount: '',
          vdcc: {
            brand: '',
            model: '',
            color: '',
          },
          idCard: [],
          attachmentList: [],
          operateRecordList: [],
        },
        modifyData: {
          status: '',
          type: '',
          content: '',
          urgency: 1,
          Insurance: 0, //是否有保险
          punishFlag: 0, //是否处罚
          punishAmount: '', //处罚金额
          Time: '',//维修扣款时间
          claimTime: '',//索赔时间
          CollectionAmount: '', //回款金额
          CollectionTime: '',//回款时间
          InsuranceNumber: '', //保险单号
          repairContent: '',//维修信息
          pricingAmount: '',//定价金额
          img: [],
        },
        baseImgUrl: baseImgUrl + '/',
        uploadUrl: '',
        importUploadUrl: '/vehicleMassLossInfo/batchImport',
        dialogVisible: false,
        addflag: false,
        addLoad: false,
        dialogImageUrl: '',
        rules: {
          repairContent: {
            required: true,
            message: '维修内容不能为空',
            trigger: 'blur',
          },
          name: [
            {
              required: true,
              message: '请输入业务名称',
              trigger: 'blur',
            },
            {
              min: 3,
              max: 9,
              message: '长度在 3 到 9 个字符',
              trigger: 'blur',
            },
          ],
          pricingAmount: {
            required: true,
            message: '请输入定价金额',
            trigger: 'blur',
          },
          punishFlag: {
            required: true,
            message: '请选择是否处罚',
            trigger: 'blur',
          },
          punishAmount: {
            required: true,
            message: '请输入处罚金额',
            trigger: 'blur',
          },
          Time: {
            required: true,
            message: '请选择维修扣款时间',
            trigger: 'blur',
          },
          Insurance: {
            required: true,
            message: '请选择是否有保险',
            trigger: 'blur',
          },
          claimTime: {
            required: true,
            message: '请选择向保险公司索赔时间',
            trigger: 'blur',
          },
          CollectionAmount: {
            required: true,
            message: '请选择保险公司回款金额',
            trigger: 'blur',
          },
          CollectionTime: {
            required: true,
            message: '请选择保险公司回款时间',
            trigger: 'blur',
          },
          InsuranceNumber: {
            required: true,
            message: '请输入保险单号',
            trigger: 'blur',
          },
          img: {
            required: true,
            message: '请选择合同照片',
            trigger: 'blur',
          },
        },
        infoLoading: false,
        addLoading: false,
      };
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
    },
    mounted() {
      this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
     // this._qualityDamageList();
    },
    methods: {
      async _qualityDamageList() {
        this.tableLoad = true;
        const res = await qualityDamageList(this.form);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },

      // 新增
      // addBtn(){
      //   // 1 为添加 2 修改
      //   this.dilogNumber = 1
      //   this.dialogTitle = "新增价格审批"
      //   this.addflag = true
      // },
      // 查询
      searchBtn() {
        this.form.page = 1;
        this._qualityDamageList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;
      },
      contractSizeChange(row) {
        this.form.rows = row;
      },
      contractCurrentChange(page) {
        this.page = page;
      },
      // 详情
      async detailClick(index, row) {
        this.infoLoading = true;
        const res = await qualityDamageDetail(row.id);
        this.infoLoading = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailDialogVisible = true;
        res.data.taskMode = res.data.taskMode == '1' ? '公路' : res.data.taskMode == '2' ? '水路' : '其他';
        res.data.status = res.data.status == '0' ? '定损金额待完善' : res.data.status == '1' ? '待付款' : '已完成';
        res.data.isPunish = res.data.isPunish == '0' ? '否' : '是';
        this.detailData = res.data;
      },
      // 完善
      async perfectClick(index, row) {
        this.addLoading = true;
        const res = await qualityDamageDetail(row.id);
        this.addLoading = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.addflag = true;
        res.data.taskMode = res.data.taskMode == '1' ? '公路' : res.data.taskMode == '2' ? '水路' : '其他';
        res.data.status = res.data.status == '0' ? '定损金额待完善' : res.data.status == '1' ? '待付款' : '已完成';
        res.data.isPunish = res.data.isPunish == '0' ? '否' : '是';
        this.detailData = res.data;
      },
      // rejectClick(){
      //   this.$confirm('确认要取消价格审批吗！', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //   }).catch(() => {});
      // },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        return isJPG && isLt10M;
      },
      uploadChange(file, fileList) {
        this.modifyData.img = fileList;
      },
      handleRemove(file, fileList) {
        this.modifyData.img = fileList;
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      closeDialog() {
        this.dialogVisible = false;
      },
      // 完善
      async addClick() {
        this.$refs.ruleForm.validate(async (valid, val) => {
          console.log('imgStr', this.modifyData);
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            // 维修信息
            let obj1 = {
              id: this.detailData.id,  // id
              maintainContent: this.modifyData.repairContent || '',  // 维修内容
              pricingAmount: this.modifyData.pricingAmount || '',  // 定价金额
              isPunish: this.modifyData.punishFlag,  // 是否处罚
              punishAmount: this.modifyData.punishAmount || '',  // 处罚金额
              processingDate: this.modifyData.Time || '',  // 维修扣款时间
            };
            const res1 = await qualityDamageRepair(obj1);
            if (res1.status !== 0) return this.$message.error(res1.message);
            // 保险信息
            let imgStr = [];
            console.log('imgStr', this.modifyData);
            if (this.modifyData.img && this.modifyData.img.length > 0) {
              this.modifyData.img.forEach(item => {
                if (item.response && item.response.status == 0) {
                  imgStr.push(item.response.data.id);
                }
              });
            }
            let obj2 = {
              id: this.detailData.id,  // id
              withInsurance: this.modifyData.Insurance,  // 是否有保险
              claimCompensationDate: this.modifyData.claimTime,  // 向保险公司索赔时间
              receivableAmount: this.modifyData.CollectionAmount,  // 保险公司回款金额
              returnedMoneyDate: this.modifyData.CollectionTime,  // 保险公司回款时间
              policyNumber: this.modifyData.InsuranceNumber,  // 保险单号
              attachmentIdStr: imgStr.join(','),  // 保险图片
            };
            this.addLoad = true;
            const res2 = await qualityDamageInsurance(obj2);
            this.addLoad = false;
            this._qualityDamageList();
            if (res2.status !== 0) return this.$message.error(res2.message);
            this.$message.success(res2.message);
            this.addflag = false;
            // for (const argumentsKey in this.modifyData) {
            //   if (argumentsKey === "img"){
            //     this.modifyData[argumentsKey] = []
            //   }else {
            //     this.modifyData[argumentsKey] = ''
            //   }
            // }
          } else {
            return false;
          }
        });
      },
      // 完善--关闭
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.addflag = false;
        // this.$emit("addclose",false)
      },
      // 运输条款
      getTaskMode(row) {
        switch (row.taskMode) {
          case 0:
            return '公路';
          case 1:
            return '水路';
        }
      },
      // 状态
      getStatus(row) {
        switch (row.status) {
          case 0:
            return '定损金额待完善';
          case 1:
            return '待付款';
          case 2:
            return '已完成';
        }
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.form.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      download() {
        window.location.href = '/file/质损信息导入模板.xlsx';
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/vehicleMassLossInfo/export?access_token=${token}&taskMode=${this.form.taskMode}&supplierName=${this.form.supplierName}&batchNumber=${this.form.batchNumber}&frameNumber=${this.form.frameNumber}&number=${this.form.number}&taskNumber=${this.form.taskNumber}`;
        window.exportExcelGet('/platform/vehicleMassLossInfo/export', `taskMode=${this.form.taskMode}&supplierName=${this.form.supplierName}&batchNumber=${this.form.batchNumber}&frameNumber=${this.form.frameNumber}&number=${this.form.number}&taskNumber=${this.form.taskNumber}`);
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
